import { render } from "./NotificationPopup.vue?vue&type=template&id=100f26ac&scoped=true"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"

import "./NotificationPopup.vue?vue&type=style&index=0&id=100f26ac&scoped=true&lang=css"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100f26ac"]])

export default __exports__